var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.select.multiple",
  title: "Control Preview: Multi Select",
  description: "Read-only preview renderer for multi-select values.",
  fields: {
    value: { title: "Value", type: "*", description: "Array, comma string, or single value." },
    preview: { title: "Preview", type: "string", description: "Preview mode (text|tags|file)." }
  }
});

function normalizeValues(value) {
  if (value instanceof Array) {
    return value.map(function(item) {
      return (item || "").toString().trim();
    }).filter(Boolean);
  }
  var raw = (value || "").toString().trim();
  if (!raw) return [];
  return raw.split(",").map(function(item) {
    return (item || "").toString().trim();
  }).filter(Boolean);
}

exports.render = async function(options) {
  var values = normalizeValues((options || {}).value);
  var mode = ((options || {}).preview || "tags").toString().trim().toLowerCase();

  if (values.length === 0) {
    return {
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    };
  }

  if (mode === "text") {
    return {
      n: "span",
      c: "ua-control-preview-text",
      i: values.join(", ")
    };
  }

  return {
    n: "div",
    c: "ua-control-preview-tags",
    i: values.map(function(item) {
      return {
        n: "span",
        c: "ua-control-preview-tag",
        i: item
      };
    })
  };
};
